import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import {
  OptionItemSquare,
  OptionItemSquareList,
} from '@/pages/Onboarding/components/OptionItemSquare';
import { useOnboarding } from '@/pages/Onboarding/context';
import { BUTT_SIZE_OPTIONS } from '@/pages/Onboarding/options/ButtSize/BUTT_SIZE_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  OwnAiTitle,
  OwnAiTitleHighlight,
} from '../../../OwnAI/components/Title';
import { LayoutDataType } from '../../types';

import { PageStyles } from './ButtSize.styles';

export const ScreenButtSize: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'ButtSize',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const butt_size = form.watch('butt_size');

  const handleSelect = (option: OnbOptionType<LayoutDataType['butt_size']>) => {
    form.setValue('butt_size', option.id);
    userService.createOrUpdate({
      onboarding_data: {
        butt_size: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <PageStyles>
      <OnboardingNavigation />
      <OwnAiTitle>
        Choose her <OwnAiTitleHighlight>butt’s size</OwnAiTitleHighlight>
      </OwnAiTitle>
      <IonContent>
        <OptionItemSquareList>
          {BUTT_SIZE_OPTIONS.map((option) => (
            <OptionItemSquare
              key={option.id}
              isSelected={butt_size === option.id}
              onClick={() => handleSelect(option)}
              bgSrc={`${S3_BUCKET_URL}/layout-own-ai-ons/butt-size/${option.id}.jpg`}
              title={option.title}
              TEST_ID={`butt_size-${option.id}`}
            />
          ))}
        </OptionItemSquareList>
      </IonContent>
    </PageStyles>
  );
};
